export default __webpack_public_path__ + "img/ring-of-leilani.ff83954a.jpg";